import * as React from 'react';

import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';
import SortableList from 'components/common/SortableList';
import type ElementConfigurationContainer from 'views/components/aggregationwizard/ElementConfigurationContainer';

import StepListItem from './StepListItem';

type SortableListItem = {
  id: string;
  title: string;
};

type GroupingsItemProps = Omit<
  React.ComponentProps<typeof ElementConfigurationContainer>,
  'testIdPrefix' | 'onRemove' | 'elementTitle' | 'children'
> & {
  item: EventProcedureStepAPIType;
};

type Props = {
  steps: Array<EventProcedureStepAPIType>;
  onMoveList: (newList: Array<EventProcedureStepAPIType>) => void;
  onViewStep: (stepId: string) => void;
  onRemoveStep: (stepId: string) => void;
};

const renderStepListItem =
  ({
    onViewStep,
    onRemoveStep,
  }: {
    steps: Array<EventProcedureStepAPIType>;
    onViewStep: (stepId: string) => void;
    onRemoveStep: (stepId: string) => void;
  }) =>
  ({ item, dragHandleProps, draggableProps, className, ref }: GroupingsItemProps) => (
    <StepListItem
      item={item}
      onViewStep={onViewStep}
      onRemoveStep={onRemoveStep}
      dragHandleProps={dragHandleProps}
      draggableProps={draggableProps}
      className={className}
      ref={ref}
    />
  );

function StepList({ steps, onMoveList, onViewStep, onRemoveStep }: Props) {
  const handleMoveList = React.useCallback((newList: Array<SortableListItem>) => onMoveList(newList), [onMoveList]);

  return (
    <SortableList<EventProcedureStepAPIType>
      items={steps}
      onMoveItem={handleMoveList}
      customListItemRender={renderStepListItem({ steps, onViewStep, onRemoveStep })}
      fullWidth
    />
  );
}

export default StepList;
